
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ALL_CATALOGS"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"a_kasser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"A_kasse_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"A_kasse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Aktivt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"genders"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Gender_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Aktivt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"indgange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Indgang_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Indgang"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Aktivt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"jc_statuser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Jc_Status_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Jc_Status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Aktivt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"jobcentre"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Jobcenter_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Jobcenter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Region"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Aktivt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"kh_statuser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Kh_Status_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Kh_Status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Kode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Aktivt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"kurser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Kursus_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Kursus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"E_learning"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Aktivt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"ansoger_vias"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Ansoger_via_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Ansoger_via"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Aktivt"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":661}};
    doc.loc.source = {"body":"query ALL_CATALOGS {\n    a_kasser {\n        A_kasse_id\n        A_kasse\n        Aktivt\n    }\n    genders {\n        Gender_id\n        Gender\n        Aktivt\n    }\n    indgange {\n        Indgang_id\n        Indgang\n        Aktivt\n    }\n    jc_statuser {\n        Jc_Status_id\n        Jc_Status\n        Aktivt\n    }\n    jobcentre {\n        Jobcenter_id\n        Jobcenter\n        Region\n        Aktivt\n    }\n    kh_statuser {\n        Kh_Status_id\n        Kh_Status\n        Kode\n        Aktivt\n    }\n    kurser {\n        Kursus_id\n        Kursus\n        E_learning\n        Aktivt\n    }\n    ansoger_vias {\n        Ansoger_via_id\n        Ansoger_via\n        Aktivt\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ALL_CATALOGS"] = oneQuery(doc, "ALL_CATALOGS");
        
